import {
  ShowFetchActionManager,
  MediaFileActionManager,
  EpisodesByShowActionManager,
} from "../../../action_managers/shows";
import { showModal } from "../../../actions/modal";
import { SHOW_DELETE_MODAL } from "../../modals/modal_root";
import { USER_IMPORT_JOB } from "../../../actions/user";
import ShowDetailsPage from "./show_details_page";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import DefaultActionManager from "../../../action_managers/default_action_manager";
import messageType from "../../../constants/message_types";
import { showMessageWithTimeout } from "../../../actions/app";
import { fetchDistributions } from "../../../action_managers/distributions";
import { submitEpisodesFeedImport } from "../../../actions/feed_import";

function mapStateToProps(state) {
  var props = {
    isLoading: state.shows.isLoading,
    distributions: state.distributions.distributions,
    errorMessage: state.shows.errorMessage,
    shows: state.shows.shows,
    user: state.user.user,
    showMediaFiles: state.mediaFiles,
    episodesByShow: state.episodesByShow,
    importJobs: state.user.importJobs,
    campaignItems: state.campaignItems,
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    fetchMediaFile: (mediaFileUUID, authToken) => {
      dispatch(new MediaFileActionManager({ mediaFileUUID, authToken }).run());
    },
    fetchDistributions: showUUID => {
      return dispatch(fetchDistributions(showUUID));
    },
    fetchEpisodesForShow: (showUUID, user) => {
      dispatch(new EpisodesByShowActionManager({ showUUID, user }).run());
    },
    fetchShow: (showUUID, user) => {
      dispatch(new ShowFetchActionManager({ showUUID, user }).run());
    },
    showSuccess: message => {
      dispatch(showMessageWithTimeout(message, messageType.Success));
    },
    showShowDeleteModal: showUUID => {
      dispatch(
        showModal(SHOW_DELETE_MODAL, {
          showUUID: showUUID,
        })
      );
    },

    submitEpisodesFeedImport: (...args) => dispatch(submitEpisodesFeedImport(...args)),

    fetchJobsForUser: user => {
      dispatch(
        new DefaultActionManager({
          auth: true,
          route: `users/${user.uuid}/import-jobs`,
          actionName: USER_IMPORT_JOB,
        }).run()
      );
    },
  };
}

const ShowDetailsPageWrapper = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShowDetailsPage)
);

export default ShowDetailsPageWrapper;
